export const GET_CHAT_PDULI_AI_REQUEST = "GET_CHAT_PDULI_AI_REQUEST";
export const GET_CHAT_PDULI_AI_SUCCESS = "GET_CHAT_PDULI_AI_SUCCESS";
export const GET_CHAT_PDULI_AI_FAIL = "GET_CHAT_PDULI_AI_FAIL";
export const GET_CHAT_PDULI_AI_RESET = "GET_CHAT_PDULI_AI_RESET";
